export const debounceCallback = (ms: number) => {
  let timeout: NodeJS.Timeout;
  return (callback: () => void) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(callback, ms);
  };
};

export const debouncedOnChange = debounceCallback(200);
